






































































































































































































































































import Vue from 'vue';

export default Vue.extend({
  components: {
  },
  data() {
    return {
    };
  },
  computed: {
    memberInfo() {
      return this.$store.state.form.ceremonyForm;
    },
  },
  methods: {
    back() {
      this.$router.push('personalHomepage');
    },
  },
});
